var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminList',{attrs:{"endpoint":'admind/users',"headers":_vm.$options.headers,"filterParams":_vm.filterParams,"dataTableSlotComponents":_vm.$options.dataTableSlotComponents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }